export default __webpack_public_path__ + "static/media/Professional-Readme-Generator.9d9dd572.JPG";